import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'telxl-loading',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    templateUrl: './loading.component.html',
    styleUrl: './loading.component.scss',
})
export class TelXLLoadingComponent {
    size = input.required<string>();
}
